module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"about":"О","about-long":"Об","download":"Скачать","program":"Программа"},"en":{"about":"About","about-long":"About","download":"Download","program":"Programme"}}')
  delete Component.options._Ctor
}
